import { handleActions } from 'redux-actions'
import { fromJS } from 'immutable'

import * as Actions from 'actions/help_center'
import * as AppActions from 'actions/app'

export const initialState = fromJS({
  demos: []
})

export default handleActions(
  {
    [Actions.fetchDemosSuccess]: (state, { payload }) => state.set('demos', fromJS(payload || [])),
    [AppActions.resetState]: () => initialState
  },
  initialState
)
